import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../firebase';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://clicksaver.app';

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .auth-root { font-family: 'Inter', sans-serif; min-height: 100vh; display: flex; background: #fff; -webkit-font-smoothing: antialiased; }

  /* Left panel */
  .auth-left {
    flex: 1; background: linear-gradient(145deg, #1e3a8a 0%, #2563eb 50%, #7c3aed 100%);
    display: flex; flex-direction: column; justify-content: space-between;
    padding: 48px; position: relative; overflow: hidden;
  }
  .auth-left::before {
    content: ''; position: absolute; top: -120px; right: -120px;
    width: 400px; height: 400px; border-radius: 50%;
    background: rgba(255,255,255,0.06); pointer-events: none;
  }
  .auth-left::after {
    content: ''; position: absolute; bottom: -80px; left: -80px;
    width: 300px; height: 300px; border-radius: 50%;
    background: rgba(255,255,255,0.04); pointer-events: none;
  }
  .auth-left-content { position: relative; z-index: 1; }
  .auth-feature { display: flex; align-items: flex-start; gap: 14px; margin-bottom: 24px; }
  .auth-feature-icon { width: 40px; height: 40px; border-radius: 10px; background: rgba(255,255,255,0.12); display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
  .auth-quote { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15); border-radius: 14px; padding: 20px 22px; position: relative; z-index: 1; }

  /* Right panel */
  .auth-right { width: 480px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px 56px; background: #fff; }
  .auth-form-wrap { width: 100%; max-width: 360px; }

  /* Input */
  .auth-label { display: block; font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 6px; }
  .auth-input {
    width: 100%; padding: 11px 14px; border-radius: 10px;
    border: 1.5px solid #e2e8f0; font-size: 14px; font-family: 'Inter', sans-serif;
    color: #0f172a; background: #fff; outline: none; transition: border-color .2s, box-shadow .2s;
  }
  .auth-input:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,0.1); }
  .auth-input::placeholder { color: #94a3b8; }

  /* Buttons */
  .auth-btn-primary {
    width: 100%; padding: 12px; border-radius: 10px; border: none; cursor: pointer;
    background: #2563eb; color: #fff; font-size: 15px; font-weight: 600;
    font-family: 'Inter', sans-serif; transition: all .2s;
    box-shadow: 0 2px 8px rgba(37,99,235,0.3);
  }
  .auth-btn-primary:hover:not(:disabled) { background: #1d4ed8; box-shadow: 0 4px 16px rgba(37,99,235,0.4); transform: translateY(-1px); }
  .auth-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
  .auth-btn-google {
    width: 100%; display: flex; align-items: center; justify-content: center; gap: 10px;
    padding: 11px 16px; background: #fff; border: 1.5px solid #e2e8f0; border-radius: 10px;
    font-size: 14px; font-weight: 600; color: #374151; cursor: pointer;
    font-family: 'Inter', sans-serif; transition: all .2s;
  }
  .auth-btn-google:hover:not(:disabled) { border-color: #bfdbfe; background: #f8faff; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
  .auth-btn-google:disabled { opacity: 0.6; cursor: not-allowed; }

  .auth-divider { display: flex; align-items: center; gap: 12px; margin: 20px 0; }
  .auth-divider-line { flex: 1; height: 1px; background: #e2e8f0; }
  .auth-divider-text { font-size: 12px; color: '#94a3b8'; font-weight: 500; }

  .auth-error { padding: 11px 14px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; color: #dc2626; font-size: 13px; margin-bottom: 16px; }

  @media (max-width: 900px) {
    .auth-left { display: none !important; }
    .auth-right { width: 100% !important; padding: 40px 24px !important; }
  }
`;

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('login'); // 'login' | 'forgot'
  const [resetEmail, setResetEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const [resetError, setResetError] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError({
        'auth/invalid-credential': 'Invalid email or password.',
        'auth/user-not-found': 'No account found with this email.',
        'auth/wrong-password': 'Incorrect password.',
        'auth/too-many-requests': 'Too many attempts. Please try again later.',
      }[err.code] || 'Sign in failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    setError('');
    setLoading(true);
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
      navigate('/dashboard');
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') setError('Google sign-in failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setResetError('');
    setResetLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email: resetEmail });
    } catch (_) {}
    setResetSent(true);
    setResetLoading(false);
  };

  return (
    <div className="auth-root">
      <style>{CSS}</style>

      {/* Left panel */}
      <div className="auth-left">
        {/* Logo */}
        <div className="auth-left-content">
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 56 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, color: '#fff', fontWeight: 800 }}>⊛</div>
            <span style={{ fontWeight: 800, fontSize: 18, color: '#fff', letterSpacing: '-0.4px' }}>ClickSaver</span>
          </Link>

          <h2 style={{ fontSize: 32, fontWeight: 900, color: '#fff', letterSpacing: '-1px', lineHeight: 1.2, marginBottom: 12 }}>
            Stop paying for<br />fake clicks.
          </h2>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.75)', lineHeight: 1.7, marginBottom: 48, maxWidth: 340 }}>
            Real-time click fraud protection that pays for itself within days.
          </p>

          {[
            { icon: '🛡️', title: 'Real-time blocking', desc: 'Fraudulent IPs blocked in under 1 second.' },
            { icon: '📊', title: 'Deep fraud analytics', desc: 'See exactly who is clicking and from where.' },
            { icon: '⚡', title: '5-minute setup', desc: 'One script tag. No developer needed.' },
          ].map((f, i) => (
            <div key={i} className="auth-feature">
              <div className="auth-feature-icon">{f.icon}</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', marginBottom: 3 }}>{f.title}</div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>{f.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonial */}
        <div className="auth-quote">
          <div style={{ display: 'flex', gap: 2, marginBottom: 10 }}>
            {[...Array(5)].map((_, i) => <span key={i} style={{ color: '#fbbf24', fontSize: 13 }}>★</span>)}
          </div>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.85)', lineHeight: 1.7, marginBottom: 12, fontStyle: 'italic' }}>
            "ClickSaver saved us over $3,200 in the first month. The setup was incredibly easy."
          </p>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)' }}>— Marcus T., Performance Marketing Manager</div>
        </div>
      </div>

      {/* Right panel */}
      <div className="auth-right">
        <div className="auth-form-wrap">
          {/* Mobile logo */}
          <div style={{ textAlign: 'center', marginBottom: 36 }}>
            <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 9 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #2563eb, #7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, color: '#fff', fontWeight: 800 }}>⊛</div>
              <span style={{ fontWeight: 800, fontSize: 18, color: '#0f172a', letterSpacing: '-0.4px' }}>ClickSaver</span>
            </Link>
          </div>

          {mode === 'forgot' ? (
            <>
              <h1 style={{ fontSize: 26, fontWeight: 800, color: '#0f172a', letterSpacing: '-0.5px', marginBottom: 6 }}>Reset password</h1>
              <p style={{ fontSize: 14, color: '#64748b', marginBottom: 28 }}>
                Enter your email and we'll send you a reset link.
              </p>

              {resetSent ? (
                <div style={{ padding: '20px 18px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, textAlign: 'center' }}>
                  <div style={{ fontSize: 32, marginBottom: 10 }}>📧</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#15803d', marginBottom: 6 }}>Check your email</div>
                  <div style={{ fontSize: 13, color: '#166534', lineHeight: 1.6 }}>
                    We sent a password reset link to <strong>{resetEmail}</strong>. Check your inbox (and spam folder).
                  </div>
                </div>
              ) : (
                <form onSubmit={handleForgot} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  <div>
                    <label className="auth-label">Email address</label>
                    <input className="auth-input" type="email" placeholder="you@company.com"
                      value={resetEmail} onChange={e => setResetEmail(e.target.value)} required autoFocus />
                  </div>
                  {resetError && <div className="auth-error">{resetError}</div>}
                  <button className="auth-btn-primary" type="submit" disabled={resetLoading}>
                    {resetLoading ? 'Sending…' : 'Send reset link →'}
                  </button>
                </form>
              )}

              <button type="button" onClick={() => setMode('login')} style={{ display: 'block', marginTop: 20, background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#64748b', fontFamily: 'Inter,sans-serif', textAlign: 'center', width: '100%' }}>
                ← Back to sign in
              </button>
            </>
          ) : (
            <>
              <h1 style={{ fontSize: 26, fontWeight: 800, color: '#0f172a', letterSpacing: '-0.5px', marginBottom: 6 }}>Welcome back</h1>
              <p style={{ fontSize: 14, color: '#64748b', marginBottom: 28 }}>
                Don't have an account? <Link to="/register" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 600 }}>Sign up</Link>
              </p>

              {/* Google */}
              <button className="auth-btn-google" onClick={handleGoogle} disabled={loading}>
                <GoogleIcon /> Continue with Google
              </button>

              <div className="auth-divider">
                <div className="auth-divider-line" />
                <span className="auth-divider-text" style={{ color: '#94a3b8' }}>or sign in with email</span>
                <div className="auth-divider-line" />
              </div>

              {/* Form */}
              <form onSubmit={handle} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label className="auth-label">Email address</label>
                  <input className="auth-input" type="email" placeholder="you@company.com"
                    value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
                </div>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <label className="auth-label" style={{ marginBottom: 0 }}>Password</label>
                    <button type="button" onClick={() => { setMode('forgot'); setResetEmail(form.email); setResetSent(false); setResetError(''); }} style={{ fontSize: 12, color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 500, padding: 0 }}>Forgot password?</button>
                  </div>
                  <input className="auth-input" type="password" placeholder="••••••••"
                    value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
                </div>

                {error && <div className="auth-error">{error}</div>}

                <button className="auth-btn-primary" type="submit" disabled={loading} style={{ marginTop: 4 }}>
                  {loading ? 'Signing in…' : 'Sign In →'}
                </button>
              </form>

              <p style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', marginTop: 28, lineHeight: 1.6 }}>
                By signing in you agree to our{' '}
                <Link to="/terms-policy" style={{ color: '#64748b', textDecoration: 'underline' }}>Terms</Link>
                {' '}and{' '}
                <Link to="/privacy-policy" style={{ color: '#64748b', textDecoration: 'underline' }}>Privacy Policy</Link>.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
